import { render, staticRenderFns } from "./EddieWidget.vue?vue&type=template&id=2c5fb231&scoped=true"
import script from "./EddieWidget.vue?vue&type=script&lang=js"
export * from "./EddieWidget.vue?vue&type=script&lang=js"
import style0 from "./EddieWidget.vue?vue&type=style&index=0&id=2c5fb231&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5fb231",
  null
  
)

export default component.exports